import { setOptions, importLibrary } from "@googlemaps/js-api-loader"
import { useAuthStore } from "@/store/auth.store.ts"
import { storeToRefs } from "pinia"
import { computed } from "vue"
import { DarkTheme } from "@/enums/theme-choices"
import { useUserSettingsStore } from "@/store/user-settings.store"

let initialized = false

export const useGoogleMaps = () => {
  const activeUserStore = useAuthStore()
  const { activeUser } = storeToRefs(activeUserStore)

  if (!initialized) {
    setOptions({
      key: activeUser.value?.activeTenant.tenantSettings?.apiKeyGoogleMaps ?? undefined,
      v: "quarterly"
    })
    initialized = true
  }

  return {
    importLibrary
  }
}

export function useGoogleMapsColorScheme() {
  const userSettingsStore = useUserSettingsStore()

  // Google Maps only reads this option at initialization.
  // https://developers.google.com/maps/documentation/javascript/mapcolorscheme
  return computed<google.maps.ColorSchemeString>(() => {
    switch (userSettingsStore.storedTheme) {
      case DarkTheme.DARK:
        return "DARK"
      case DarkTheme.SYSTEM:
        return "FOLLOW_SYSTEM"
      default:
        return "LIGHT"
    }
  })
}

export function getGoogleMapsViewOptions(map: google.maps.Map | null): google.maps.MapOptions {
  if (!map) return {}

  return {
    center: map.getCenter(),
    zoom: map.getZoom(),
    heading: map.getHeading(),
    tilt: map.getTilt(),
    mapTypeId: map.getMapTypeId()
  }
}
